/* eslint-disable */

webpackJsonp([14],{

/***/ 										10:
	/***/ (function(module, exports, __webpack_require__) {

		"use strict";

		var _waypoint = __webpack_require__(1);

		var _waypoint2 = _interopRequireDefault(_waypoint);

		var _timelinelite = __webpack_require__(0);

		var _timelinelite2 = _interopRequireDefault(_timelinelite);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		// hero animations
		var t = new _timelinelite2.default();

		var hero = document.querySelector(".q-alternate-hero");
		var heroContent = document.querySelector(".q-alternate-hero__content");
		var text = heroContent.childNodes;
		var heroImage = document.querySelector(".q-alternate-hero__image-wrap");

		new _waypoint2.default({
			element: hero,

			offset: "100%",

			handler: function handler(direction) {
				if (direction === "down") {
					t.addLabel("start").staggerFromTo(text, 1, { y: "20%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: window.Power4.easeInOut }, 0.1).fromTo(heroImage, 1, { y: "-30%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: window.Power4.easeInOut }, "start+=.8");
				}
			}
		});

		/***/ }),

	/***/ 										30:
	/***/ (function(module, exports) {

		// removed by extract-text-webpack-plugin

		/***/ }),

	/***/ 										64:
	/***/ (function(module, exports, __webpack_require__) {

		__webpack_require__(10);
		module.exports = __webpack_require__(30);


		/***/ })

},[64]);
/* eslint-enable */

/*
 * append the leadsource to the iframe URL
 */

(function () {

	"use strict";

	var iframe, matches;

	if (window.location.search) {

		matches = window.location.search.match(/leadsource=(\d+)([;&#]|$)/);
		if (matches) {

			iframe = document.querySelector("iframe[name=salesforce]");
			if (iframe && !iframe.src.match(/\?/)) {

				iframe.src += "?leadsource=" + matches[1];

			}

		}

	}

}());




